import { AlertCircle, Info, type LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';

export type BannerProps = {
  children: ReactNode;
  className?: string;
  testId?: string;
};

type BannerTone = {
  Icon: LucideIcon;
  containerClassName: string;
  iconClassName: string;
};

const WARNING_TONE: BannerTone = {
  Icon: AlertCircle,
  containerClassName: 'border-warning-300 bg-warning-50',
  iconClassName: 'text-warning-700',
};

const INFO_TONE: BannerTone = {
  Icon: Info,
  containerClassName: 'border-status-info-200 bg-status-info-50',
  iconClassName: 'text-status-info-800',
};

function Banner({
  tone: { Icon, containerClassName, iconClassName },
  children,
  className = '',
  testId,
}: Readonly<BannerProps & { tone: BannerTone }>) {
  return (
    <div
      data-testid={testId}
      className={`rounded-md border ${containerClassName} p-2 flex items-start gap-2 ${className}`}
    >
      <Icon
        className={`w-4 h-4 ${iconClassName} shrink-0 mt-0.5`}
        aria-hidden
      />
      <p className="text-xs font-medium text-neut-prim">{children}</p>
    </div>
  );
}

export function WarningBanner(props: Readonly<BannerProps>) {
  return <Banner tone={WARNING_TONE} {...props} />;
}

export function InfoBanner(props: Readonly<BannerProps>) {
  return <Banner tone={INFO_TONE} {...props} />;
}
